import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { Customer } from './customer';
import { AbstractUiEntityStore } from '../../data/abstract-ui-entity.store';

export interface CustomerWindowState extends EntityState<Customer, number> {
    ui: {
        contactId: number,
        headerTitle: {
            contactId?: number,
            newTitle?: string
        }
    };
}

@Injectable({
    providedIn: 'root'
})
@StoreConfig({ name: 'customer-window' })
export class CustomerWindowStore extends AbstractUiEntityStore<CustomerWindowState> {
    constructor() {
        super({
            ui: {
                contactId: -1,
                headerTitle: {}
            }
        })
    }

    // decreaseTotalUnread(): void {
    // 	this.updateUi({
    // 		totalUnread: this._value().ui.totalUnread - 1
    // 	})
    // }

    openThisContact(contactId: number) {
        this.updateUi({
            contactId,
        })
    }

    updateHeaderTitle(contactId: number, newTitle: string) {
        this.updateUi({
            headerTitle: {
                contactId,
                newTitle
            }
        })
    }
}